<template>
  <div >
    <v-card class="grey lighten-5 shadow-1 pa-3 card-r">
      <v-container fluid class="pa-0">

        <v-layout row wrap class="ml-1">
          <v-flex lg6 sm6 md6 xs12 class="pa-1">
            <div class="text-primary w-100 pl-1 f-15 font-weight-bold">Question Category</div>
            <v-select solo class="pa-0 ma-0" v-model="selectedType" @change="filterWithCategory"
                      item-text='text' item-value='value' :items="test_type" label="Filter by Category"></v-select>
          </v-flex>
          <v-flex lg6 sm6 md6 xs12 class="pa-1">
            <div class="text-primary w-100 pl-1 f-15 font-weight-bold">Language Category</div>
            <v-select solo class="pa-0 ma-0" v-model="selectedLangType" @change="filterWithLangCategory"
                      item-text='text' item-value='value' :items="lang_type" label="Filter by language"></v-select>
          </v-flex>
        </v-layout>


        <v-layout row wrap>
          <v-flex xs12 lg3 class="text-xs-center">
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <v-alert
              :value="true"
              v-if="alertType"
              :type="alertType"
            >
              {{alertMsg}}
            </v-alert>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 lg3 v-for="(n, index) in DraftQuestions.data">
            <v-card class="ma-2">
              <!-- <img v-if="n.picture==null" src="https://cdn.vuetifyjs.com/images/cards/road.jpg" height="300"
                   class="w-100 card-r"/>
               <img v-if="n.picture!=null" :src="n.picture" height="300" class="w-100 card-r"/> -->
              <v-img v-if="n.picture!=null" :src="n.picture" height="250px">
                <div class="text-xs-right w-100">
                  <!-- <v-btn small class="grey" icon @click="deleted = true"><v-icon class="f-20 text-white">delete</v-icon></v-btn> -->
                  <v-btn @click="deleteQuestion(n.id)" small class="grey" icon><v-icon class="f-20 text-white">delete</v-icon></v-btn>
                  <v-btn small class="grey" icon :to="'/EditQuestions/'+n.id"><v-icon class="f-20 text-white">edit</v-icon></v-btn>
                </div>
              </v-img>

              <v-img v-if="n.picture==null" src="https://cdn.vuetifyjs.com/images/cards/road.jpg" height="250px">
                <div class="text-xs-left w-100">
                  <v-btn @click="deleteQuestion(n.id)" small class="grey" icon><v-icon class="f-20 text-white">delete</v-icon></v-btn>
                  <v-btn small class="grey" icon :to="'/EditQuestions/'+n.id"><v-icon class="f-20 text-white">edit</v-icon></v-btn>
                </div>
              </v-img>
              <v-card-title @click="setQuestionValues(n)" primary-title class="shade-color-white pa-2 f-12">
                <div>
                  <p> {{n.situation}}</p>
                </div>
              </v-card-title>
              <!-- <v-card-actions class="shade-color-white transparent">
                <v-spacer></v-spacer>
                <v-btn small @click="publishQuestion(n.id)" class="black no-shadow card-r text-white">Post</v-btn>
              </v-card-actions> -->
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 lg8 d-flex class="w-100 align-center justify-center text-xs-center">
            <div class="right text-xs-center text-lg-right">
              <v-pagination
                v-model="selectedPage"
                :length="DraftQuestions.last_page"
                @input="loadPaginationQuestions(selectedPage)"
                total-visible=10
              ></v-pagination>
            </div>
          </v-flex>

          
          <v-flex xs8 lg2 class="translate-box text-xs-center">
            <v-text-field solo
                          type="number"
                          placeholder="Search Pagination"
                          class="pa-0 pt-2 ma-0 f-12" label="Phone" v-model="findPageNumber">
            </v-text-field>
          </v-flex>
          <v-flex xs4 lg2 class="pt-3">
            <v-btn @click="loadPaginationQuestions(findPageNumber)" small class="ma-0 mt-1 secondary card-r">go</v-btn>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-dialog v-model="view" persistent max-width="800px" class="view-pop">
            <v-card dark class="ex-bg no-shadow">
              <v-btn icon class="right" @click="view = false"><v-icon>close</v-icon></v-btn>

              <v-card-title class="headline">{{viewQuestionDetails.category}}</v-card-title>
               <img v-if="viewQuestionDetails.picture==null" src="https://cdn.vuetifyjs.com/images/cards/road.jpg" height="300"
                   class="w-100 card-r"/>
               <img v-if="viewQuestionDetails.picture!=null" :src="viewQuestionDetails.picture" height="300" class="w-100 card-r"/>

               <v-card-title primary-title class=" pa-0 pl-3 pr-3">
                <div class="w-100">
                  <v-layout row wrap class="">
                    <v-flex xs12 class="text-xs-left">
                      <div class="f-20 text-white">{{viewQuestionDetails.situation}}</div>
                    </v-flex>
                    <v-flex xs12 class="text-xs-left">

                    <vuetify-audio class="no-shadow" :file="viewQuestionDetails.situation_audio" :ended="audioFinish"></vuetify-audio>
                    </v-flex>
                    <!-- <v-flex xs1 class="text-xs-right pt-2">
                      <v-icon v-show="!spaker" v-on:click='spaker = !spaker' class="card-r text-white">volume_up</v-icon>
                      <v-icon v-on:click='spaker = !spaker' v-show="spaker" class="card-r text-white">volume_off</v-icon>
                    </v-flex> -->
                  </v-layout>
                </div>


               
                <v-layout row wrap class="f-20 text-weight-bold mt-2 mb-4 text-center"> Question Details </v-layout>
                <v-layout row wrap class="mb-2 mt-2 w-100" v-for="(n, index) in 4">
                  <v-flex xs12 class="text-xs-left" v-if="viewQuestionDetails['q'+(index+1)]">
                    <div class="f-15 text-white"> {{n}}. {{viewQuestionDetails['q'+(index+1)]}}</div>
                     <!-- <div class="f-15 text-white">{{viewQuestionDetails['q'+(index+1)+'_audio']}}</div> -->
                     <div v-if="viewQuestionDetails['q'+(index+1)+'_audio']"> Question audio </div>
                     <vuetify-audio v-if="viewQuestionDetails['q'+(index+1)+'_audio']" class="no-shadow" :file="viewQuestionDetails['q'+(index+1)+'_audio']" :ended="audioFinish"></vuetify-audio>
                    <div v-if="viewQuestionDetails['a'+(index+1)]" class="f-15 text-green-light">Answer - {{viewQuestionDetails['a'+(index+1)]}}</div>
                    <div class="f-15 text-green-light" v-if="viewQuestionDetails['a'+(index+1)+'_audio']"> Answer audio </div>
                     <vuetify-audio v-if="viewQuestionDetails['a'+(index+1)+'_audio']" class="no-shadow" :file="viewQuestionDetails['a'+(index+1)+'_audio']" :ended="audioFinish"></vuetify-audio>
                  </v-flex>
                  <!-- <v-flex v-if="viewQuestionDetails['q'+(index+1)]" xs3 class="text-xs-right align-self-center">
                    <v-btn v-show="!check" v-on:click='check = !check' icon class="green text-white ma-0"><v-icon>check</v-icon></v-btn>
                    <v-btn v-show="check" v-on:click='check = !check' icon class="red text-white ma-0"><v-icon>close</v-icon></v-btn>
                  </v-flex> -->
                </v-layout>
              </v-card-title>

            </v-card>
          </v-dialog>
          <v-dialog v-model="deleted" max-width="290">
            <v-card>
              <v-card-title class="headline">Are you sure want to delete?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="grey text-white" text @click="deleted = false">NO</v-btn>
                <v-btn class="primary" text @click="deleted = false">Yes</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
  /*eslint-disable */

  import api from "@/utils/backend-api"
  import { mapState } from 'vuex'
  import router from "@/router"
  import VuetifyAudio from 'vuetify-audio';


  export default {
    props:['id'],
    data: () => ({
      loading:false,
      selectedPage: 1,
      findPageNumber:'',
      view:false,
      deleted:false,
      alertMessage:'',
      alertMsg:'',
      alertType:'',
      workMin: ['45', '90', '135', '180'],
      typs: ['Random', 'Mannual'],
      show: false,
      items: [
        'Tests 1',
        'Tests 2',
        'Tests 3',
        'Tests 4',
        'Tests 5',
        'Tests 6',
        'Tests 7',
        'Tests 8',
        'Tests 9',
        'Tests 10'
      ],
      draftData:[],
      selectedLangType:'all',
      selectedType:'all',
      lang_type:[
        {text:'Danish',value:'da'},
        {text:'English',value:'en'},
      ],
      test_type: [],
      selectedTests:'',
      viewQuestionDetails:'',
      alert:{
        msg:'',
        type:''
      },
      check:'',
      spaker:''
    }),
    created:function(){
      this.loadDraftQuestions()
    },

    watch:{
      questionsCategories:function(){
        this.setCategories()
      },
      questionsLangCategories:function(){
        this.setLangCategories()
      }
    },

    methods:{

      setQuestionValues(questionDetails){
        console.log(questionDetails)
        this.viewQuestionDetails=questionDetails
        this.view=true
      },
      
      loadPaginationQuestions(page){
        this.selectedPage=parseInt(page)
        console.log("Hello "+page)
        api.postData('driver/viewDraftQuestions?page='+page,{pagination:12})
          .then(res=>{
            Store.dispatch('setDraftQuestions', res.data)
          })
      },


    loadQuestionCategories(){
        api.getData('driver/viewQuestionCategory')
          .then(res=>{
            Store.dispatch('setQuestionsCategories', res.data)
          })
      },

      
      filterWithCategory(){
        let type=this.selectedType
        api.postData('driver/viewDraftQuestions',{category:this.selectedType=='all'?'':this.selectedType,pagination:12})
          .then(res=>{
            Store.dispatch('setDraftQuestions', res.data)
            // self.questionsInfo=res.data
          }).catch(err=>{
          Store.dispatch('setDraftQuestions', [])
        })

      },


        setCategories(){
        let test_type=this.questionsCategories

        let newtype=[]
        let allType={
          text:'all',
          value:'all'
        }
        newtype.push(allType)
        this.test_type=newtype
        for(let x=0;x<test_type.length;x++){
          let type={
            text:test_type[x],
            value:test_type[x]
          }
          newtype.push(type)
        }
        let nullType={
          text:'others',
          value:null
        }
        newtype.push(nullType)
        this.test_type=newtype
      },



      filterWithLangCategory(){
        let type=this.selectedLangType
        api.postData('driver/viewDraftQuestions',{lang:this.selectedLangType=='all'?'':this.selectedLangType,pagination:12})
          .then(res=>{
            Store.dispatch('setDraftQuestions', res.data)
            // self.questionsInfo=res.data
          }).catch(err=>{
          Store.dispatch('setDraftQuestions', [])
        })

      },


      // loadPaginationQuestions(page){
      //   this.selectedPage=parseInt(page)
      //   console.log("Hello "+page)

      //   api.postData('driver/viewQuestions?page='+page,
      //     {category:this.selectedType=='all'?'':this.selectedType,pagination:12,lang:this.selectedLangType})
      //     .then(res=>{
      //       Store.dispatch('setQuestionsList', res.data)
      //     })
      // },

      deleteQuestion(questionId){
        let self=this
        this.loading=true
        api.getData('driver/deleteQuestion/'+questionId)
          .then(res=>{
            self.loading=false
            self.alertType="success"
            self.alertMsg="Successfully deleted"
            self.loadDraftQuestions()
          }).catch(err=>{
          self.loading=false
          self.alertType="error"
          self.alertMsg="question failed to delete"
        })
      },

      publishQuestion(id){
        let self=this
        api.postData('driver/updateDraftQuestion',{status:'draft',question_id:id})
          .then(res=>{
            if(res.status==201){
              self.alert.msg="Successfully posted"
              self.alert.type="success"
              self.loadDraftQuestions()
            }
          })
      },
      loadDraftQuestions(){
        api.postData('driver/viewDraftQuestions',{pagination:12})
          .then(res=>{
            Store.dispatch('setDraftQuestions', res.data)
            // this.draftData=res.data.data
          })
      },
      updatePackage(packageId){
        this.loading=true
        this.alertMessage=''
        this.alertType=''
        let self=this
        let theory_test=this.selectedTests
        let selectedTests=[]
        if(theory_test){
          theory_test.forEach(element => {
            selectedTests.push(element.id)
          });
        }

        let Data={
          valid_for:this.packagaData.valid_for,
          price:parseInt(this.packagaData.price),
          test_package_id:packageId,
          theory_test:selectedTests,
          description:this.packagaData.description,
          name:this.packagaData.name
        }
        api.postData('driver/updateTestPackage',Data)
          .then(res=>{
            if(res.status==201){
              self.loading=false
              self.alertMessage="Successfully created"
              self.alertType='success'
              router.push('/examstab#packages')
            }else{
              self.alertType='error'
              self.alertMessage="Failed to update"
            }

          }).catch(err=>{
          self.loading=false
          self.alertType='error'
          self.alertMessage="Failed to update"
        })
      }
    },
    computed: {
      ...mapState({
        DraftQuestions: 'DraftQuestions',
        questionsList: 'questionsList',
        questionsCategories:'questionsCategories',
        questionsLangCategories:'questionsLangCategories'
      }),
    },

    components: {
      'vuetify-audio': VuetifyAudio
    },
  }
</script>



// WEBPACK FOOTER //
// src/pages/pages/exams/Draft.vue